import React from 'react'
import { connect } from 'react-redux'
import { acknowledgeReferral } from '../../redux/modules/friends'
import { SuccessModal } from '../success-modal/SuccessModal'

const ReferralSuccessNotification = props => {
  const { acknowledgeReferral, referralSuccess } = props

  return referralSuccess ? (
    <SuccessModal
      message="🎉 Your credit will be available at checkout!"
      onClose={acknowledgeReferral}
      title=""
    />
  ) : null
}

const mapStateToProps = state => {
  const { referralSuccess } = state.friends
  return { referralSuccess }
}

const mapDispatchToProps = { acknowledgeReferral }

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralSuccessNotification)
